module.exports = __webpack_public_path__ + "linea-ecommerce-10.86d8ba2ca6a7c6fe4442.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/linea/ecommerce/fonts/linea-ecommerce-10.svg
// module id = ../../../../../src/assets/fonts/linea/ecommerce/fonts/linea-ecommerce-10.svg
// module chunks = styles